import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import Prismic from 'prismic-javascript';
import { Link } from 'react-router-dom';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import BarWhereFind from '../../components/bar-where-find';

import LanguageContext from '../../context/LangContext';

class OndeEncontrar extends Component {
  state = {
    seo: {}
  }

  componentDidMount = () => {
    const { language } = this.context;
    if (language !== 'pt-br')
      this.props.history.push('/onde-encontrar/compensados');
    window.scrollTo(0, 0)
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchDataSeo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'onde_encontrar')
      )
      if (response.results[0]) {
        this.setState({seo: response.results[0].data});
      }
    }
    fetchDataSeo();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== 'pt-br')
      this.props.history.push('/onde-encontrar/compensados');
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let ondeEncontrar = ''
    switch (language) {
      case 'pt-br':
        home = 'Inicio';
        ondeEncontrar = 'Onde encontrar';
        break;
      case 'en-us':
        home = 'Home';
        ondeEncontrar = 'Where to find';
        break;
      case 'es-es':
        home = 'Inicio';
        ondeEncontrar = 'Donde encontrar';
        break;
      default:
    }
    const {seo} = this.state;
    return (
      <div id="home">
        <MetaTags>
          <title>{ seo.meta_title }</title>
          <meta id="meta-description" name="description" content={ seo.meta_description } />
          <meta id="og-title" property="og:title" content={ seo.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ ondeEncontrar }>
          <div>
            <Link to="/">{ home }</Link>
            <span>{ ondeEncontrar }</span>
          </div>
        </Breadcrumbs>
        <BarWhereFind active="produtos" />
        <main>
          <iframe title="Go find iframe" id="gofind-iframe" frameborder="0" src="https://guararapes.pertinhodemim.com" style={ { display: 'flex', width: '100%', minHeight: '600px', border: '0' } } allow="geolocation"></iframe>
        </main>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

OndeEncontrar.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

OndeEncontrar.contextType = LanguageContext;

export default OndeEncontrar;
